import type { Product } from "@/types";

import {
  authenticatedClient,
  type RequestOptions,
} from "./authenticated-client";
import { checkoutResponseSchema } from "./schemas";

function createSession(productId: Product["id"], options?: RequestOptions) {
  return authenticatedClient
    .post(`/v2/checkout/${productId}`, options)
    .json(checkoutResponseSchema);
}

const checkoutApi = { createSession };

export { checkoutApi as CheckoutApi };
